/*
 * NUHO KOL referral capture
 *
 * - Reads ?ref=<slug> from the URL on every page load.
 * - Persists it in localStorage for 30 days (last-touch wins).
 * - Attaches it to the cart as note_attributes.kol_ref so the slug
 *   ends up on every order placed within the attribution window.
 *
 * No discount is applied. This is purely an attribution tag.
 */
(function () {
  var STORAGE_KEY = 'nuho_kol_ref';
  var TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
  var SLUG_RE = /^[a-zA-Z0-9_-]{1,40}$/;

  function readStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.code || !obj.ts) return null;
      if (Date.now() - obj.ts > TTL_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return obj.code;
    } catch (e) {
      return null;
    }
  }

  function store(code) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ code: code, ts: Date.now() })
      );
    } catch (e) {}
  }

  // 1. Capture from URL (last-touch overwrite).
  try {
    var params = new URLSearchParams(window.location.search);
    var fromUrl = params.get('ref');
    if (fromUrl && SLUG_RE.test(fromUrl)) {
      store(fromUrl);
    }
  } catch (e) {}

  var code = readStored();
  if (!code) return;

  // 2. Sync to cart attributes if not already set.
  function syncCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var current = cart && cart.attributes && cart.attributes.kol_ref;
        if (current === code) return;
        var fd = new FormData();
        fd.append('attributes[kol_ref]', code);
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          body: fd,
        });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCart);
  } else {
    syncCart();
  }
})();
